import {regChannel} from "@/services/common";

const buriedPoint = {
    data() {
        return {
        };
    },
    // computed: {
    // },
    methods: {
        loginBuriedPoint(type, channel) {
            let pointByKey = localStorage.getItem("pointByKey")
            if (pointByKey) {
                pointByKey = JSON.parse(pointByKey);
                // 首页申请埋点
                if (pointByKey.type == 2 && pointByKey.register) {
                    // google埋点
                    console.log(
                        "homeBuriedPoint 调用 google埋点",
                        channel,
                        pointByKey.register
                    );
                    window.gtag("event", "conversion", {
                        send_to: pointByKey.register,
                    });
                }
            }
        },
        async homeBuriedPoint(channel) {
            let regChannle = await regChannel()
            let regChannleKey = regChannle.result.channelKey;
            let pointByKey = localStorage.getItem("pointByKey")
            if (pointByKey && regChannleKey && regChannleKey == channel) {
                pointByKey = JSON.parse(pointByKey);
                // 首页申请埋点
                if (pointByKey.type == 2 && pointByKey.apply) {
                    // google埋点
                    console.log(
                        "homeBuriedPoint 调用 google埋点",
                        channel,
                        pointByKey.apply
                    );
                    window.gtag("event", "conversion", {
                        send_to: pointByKey.apply,
                    });
                }
            }
        },
    },
};

export default buriedPoint;
